// This icon file is generated automatically.
var PFlagOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 3.77h-4V2a.5.5 0 00-.5-.5H1.87V.87a.13.13 0 00-.12-.12H.87a.13.13 0 00-.12.13v12.24c0 .07.06.13.13.13h.87c.07 0 .13-.06.13-.13V9h3.87v1.77c0 .27.22.5.5.5h6.5a.5.5 0 00.5-.5v-6.5a.5.5 0 00-.5-.5zM1.87 7.87V2.63h5.75v5.25H1.88zm10.25 2.27H6.88V9h1.75c.06 0 .12-.06.12-.13V4.9h3.38v5.25z", "fill-rule": "nonzero" } }] }, "name": "p-flag", "theme": "outlined" };
export default PFlagOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFlagOutlined.js
// module id = 3414
// module chunks = 0